import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Link, Typography } from '@material-ui/core';

import ViewHeadlineIcon from '@material-ui/icons/ViewHeadline';
import LaunchIcon from '@material-ui/icons/Launch';

const useStyles = makeStyles((theme) => style(theme));

function Description ({
    description,
    url
}) {
    const classes = useStyles();

    return (
        <div className={classes.root}>
            <Typography className={classes.textWithIcon} variant="subtitle1">
                <ViewHeadlineIcon />&nbsp;Description
            </Typography>
            <Typography variant="body2">
                {description}
            </Typography>
            <Link
                className={classes.textWithIcon}
                href={url}
                target="_blank"
                underline="none"
                variant="caption"
            >
                <LaunchIcon />&nbsp;View full planning application
            </Link>
        </div>
    );
}

const style = theme => ({
    root: {
        // padding: 12,
        '&> *': {
            padding: 0,
            '&:not(:last-child)': {
                paddingBottom: 6
            },
            '&:not(:first-child)': {
                paddingTop: 6
            }
        }
    },
    optional: {
        display: 'flex',
        justifyContent: 'space-between'
    },
    textWithIcon: {
        display: 'flex',
        alignItems: 'center',
        lineHeight: 1,
        '& > svg': {
            fontSize: '12px'
        }
    }

});

export default Description;